import {createFileRoute} from '@tanstack/react-router'

import {WorkerTypeDetailsPage} from '../../../../assets/worker-types/worker-type-details-page'

export const Route = createFileRoute('/_app/workers/types/$typeId')({
    component: WorkerTypeDetailsRoute,
})

function WorkerTypeDetailsRoute() {
    const {typeId} = Route.useParams()
    return <WorkerTypeDetailsPage typeId={typeId} />
}
